import { push } from 'connected-react-router';
import queryString from 'query-string';
import * as PAGE from '../../constants/assessmentItemType';
import { START, DONE, STUDENT_ASSESSMENT, INTERSTITIAL } from '../../constants/url';
import selectors from '../../rootSelectors';
import { LANGUAGE } from '../../constants/language';

const pageUrl = ({ measure, measureType, page }) => {
    if (measureType) {
        return `${STUDENT_ASSESSMENT}/${measure}/${measureType}/${page}`;
    }
    return `${STUDENT_ASSESSMENT}/${measure}/${page}`;
};

export const goTo = (pageURL, query) => {
    const pathname = pageURL.startsWith(STUDENT_ASSESSMENT) ? pageURL :
        `${STUDENT_ASSESSMENT}/${pageURL.startsWith('/') ? pageURL.substring(1) : pageURL}`;
    if (!query) {
        return push(pathname);
    }
    const location = {
        pathname,
        search: `?${queryString.stringify(query)}`,
    };
    return push(location);
};

export const goToMeasurePage = (measure, measureType, pageType, questionIndex, lang) => {
    let url = `${pageUrl({ measure, measureType, page: pageType })}`;
    let query;
    if (questionIndex) {
        url += `/${questionIndex}`;
    }
    // only add lang to url if it's spanish
    if (lang === LANGUAGE.SPA) {
        query = { lang };
    }
    return goTo(url, query);
};

export const goToDirections = (measure, measureType) => push(pageUrl({ measure, measureType, page: PAGE.DIRECTIONS }));

export const goToOpening = (measure) => push(pageUrl({ measure, page: PAGE.OPENING }));

export const goToModel = (measure, measureType) => push(pageUrl({ measure, measureType, page: PAGE.MODEL }));

export const goToPractice = (measure, measureType) => push(pageUrl({ measure, measureType, page: PAGE.PRACTICE }));

export const goToModelScroll = (measure, measureType) => push(pageUrl({ measure, measureType, page: PAGE.SCROLL }));

export const goToInstructions = (measure, measureType) => push(pageUrl({ measure, measureType, page: PAGE.INSTRUCTIONS }));

export const goToReady = (measure) => push(pageUrl({ measure, page: PAGE.READY }));

export const goToQuestion = (measure, measureType, questionIndex) => {
    return (dispatch, getState) => {
        const language = selectors.getCurrentLanguage(getState());
        return dispatch(
            goToMeasurePage(measure, measureType, PAGE.QUESTIONS, questionIndex, language));
    };
};

export const goToPassage = (measure, measureType, passageIndex) => goToMeasurePage(measure, measureType, PAGE.PASSAGE, passageIndex);

export const goToCountdown = (measure, measureType, questionIndex) => {
    return (dispatch, getState) => {
        const language = selectors.getCurrentLanguage(getState());
        return dispatch(
            goToMeasurePage(measure, measureType, PAGE.COUNTDOWN, questionIndex, language));
    };
};

export const goToReading = (measure) => push(pageUrl({ measure, page: PAGE.READING }));

export const goToBookStart = (measure) => push(pageUrl({ measure, page: PAGE.BOOK }));

export const goToInterstitial = () => push(INTERSTITIAL);

export const goToStartPage = () => push(START);

export const goToDonePage = () => push(DONE);

export const goToItems = (measure, measureType) => goToMeasurePage(measure, measureType, PAGE.ITEMS);
